import React, { useEffect } from "react"
import { useTableContext } from "../../provider"
import { getPageSizeValue } from "../../helpers"

export const InitializerPageSize = () => {

  const ctx = useTableContext()
  const { tableId } = ctx.props

  useEffect(() => {
    const value = getPageSizeValue(tableId)
    ctx.data.api.setPageSize(value)
    ctx.muiGridApiRef.current?.setPageSize(value)
    ctx.lifecycle.increment()
  }, [])

  return (<></>)
}
